export enum PermissionToDelegateEnum {
  AdminReview = 1,
  ApproveAccordances
}
